module.exports = __webpack_public_path__ + "img/doorpostscene3.4e8666a2.png";